import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setFullscreen } from '../../../store/CommonSlice';
import { setChangeTime, setCurrentTime, setPlay, setRange } from '../../../store/VideoSlice';
import { Button } from '../../_atoms/Button';
import { Input } from '../../_atoms/Input';
import { VideoPlayerTime } from '../../_molecules/VideoPlayerTime';

const ProgressBarWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 82px;
  background-color: #555;
`;

export const VideoProgressWrap = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  return (
    <ProgressBarWrap>
      <Button type="play" className={state.video.play && 'act'} onClick={() => dispatch(setPlay(!state.video.play))}/>
      <Input
        type="range" 
        name="progress" 
        video={true}
        min={0}
        max={100}
        step={1}
        className={'progress'}
        value={isNaN(state.video.range) ? 0 : state.video.range}
        onChange={(e) => {
          dispatch(setRange(isNaN(e.target.value) ? 0 : e.target.value));
          dispatch(setCurrentTime(parseInt(state.video.duration * e.target.value / 100)));
          dispatch(setChangeTime(parseInt(state.video.duration * e.target.value / 100)));
        }}
      />
      <VideoPlayerTime />
      <Button type="fullscreen" onClick={() => dispatch(setFullscreen(true))}/>
    </ProgressBarWrap>
  );
};